import React, { useState, useEffect } from "react";
import { Button, Form, Icon } from "tabler-react";
import { Crud_Catalogos } from "../../herramientas/Crud_Catalogos";
import { NotificationManager } from 'react-notifications';
import FixRequiredSelect from "../../components/validations/FixRequiredSelect";
import BaseSelect from "react-select";
import "./RemolquesForm.css";

const RemolquesForm = ({
  accion,
  elementos,
  cerrarModal,
  idTransportista,
  onSave,
  // Cuando es true (solo catálogo normal de remolques), se crea un registro por
  // cada plataforma del usuario (transportista de menor id por plataforma).
  // En cualquier otro flujo (naviero, etc.) se liga solo a idTransportista.
  multiPlataforma = false
}) => {
  const [formulario, setFormulario] = useState({
    placa: "",
    economico: "",
    tipoRemolque: null
  });

  const [remolquesOpciones, setRemolquesOpciones] = useState([]);
  const [crudbutonEnable, setCrudbutonEnable] = useState(true);
  // Un transportista representativo (menor id) por cada plataforma del usuario.
  const [transportistasPorPlataforma, setTransportistasPorPlataforma] = useState([]);

  useEffect(() => {
    // Calcular un transportista por plataforma (menor id) para crear un remolque por plataforma.
    const usuario = JSON.parse(sessionStorage.getItem("usuario"));
    const currentUserSession = JSON.parse(sessionStorage.getItem("currentUser"));
    if (usuario && currentUserSession) {
      const plataformasIds = [...new Set(currentUserSession.map(c => c.plataforma?.id).filter(Boolean))];
      Promise.all(plataformasIds.map(idPlat =>
        Crud_Catalogos("usuarios_transportistas/usuario/" + usuario.id + "/plataforma/" + idPlat, "", "get", "", [], "", "", "", [])
          .then(res => ({ idPlataforma: idPlat, transportistas: res || [] }))
          .catch(() => ({ idPlataforma: idPlat, transportistas: [] }))
      )).then((resultados) => {
        const seleccion = resultados
          .map(r => {
            const ids = [...new Set(
              (r.transportistas || [])
                .filter(t => t.idTransportista !== null)
                .map(t => t.idTransportista)
            )].sort((a, b) => a - b);
            return ids.length > 0 ? { idPlataforma: r.idPlataforma, idTransportista: ids[0] } : null;
          })
          .filter(Boolean);
        setTransportistasPorPlataforma(seleccion);
      }).catch(err => console.error("Error al cargar transportistas:", err));
    }
  }, []);

  useEffect(() => {
    // Cargar tipos de remolques
    const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    const idPerfil = currentUser[0].perfil.id;
    const esTransportista = idPerfil === 2925 || idPerfil === 4608;
    const remolquesTipoEndpoint = esTransportista ? "remolquesTipo/perfil/" + idPerfil : "remolquesTipo";

    Crud_Catalogos(remolquesTipoEndpoint, "", "get", "", [], "", "", "", []).then((returnVal) => {
      let remolquesTemp = [{label: "Selecciona una opción", value: ""}];
      returnVal.forEach(remolque => {
        remolquesTemp.push({value: remolque.idRemolque, label: remolque.nombre});
      });
      setRemolquesOpciones(remolquesTemp);
    });

    // Si es edición, cargar datos
    if (accion === "editar" && elementos) {
      setFormulario({
        placa: elementos.placa || "",
        economico: elementos.economico || "",
        tipoRemolque: elementos.remolquesTipos ? {
          value: elementos.remolquesTipos.idRemolque, 
          label: elementos.remolquesTipos.nombre
        } : null
      });
    }
  }, []);

  const SelectRemolques = props => (
    <FixRequiredSelect
      {...props}
      SelectComponent={BaseSelect}
      options={remolquesOpciones}
    />
  );

  // Función para vincular un remolque existente al transportista actual
  const vincularRemolqueExistente = async (placa, idTransp) => {
    try {
      // Buscar el remolque por placa en todos los remolques
      const todosRemolques = await Crud_Catalogos("remolques", "", "get", "", [], "", "", "", []);
      const remolqueExistente = todosRemolques.find(
        r => r.placa?.toUpperCase().trim() === placa.toUpperCase().trim()
      );

      if (!remolqueExistente) {
        NotificationManager.error("Error al guardar el remolque", "Error");
        setCrudbutonEnable(true);
        return;
      }

      // Verificar si ya tiene relación activa con este transportista
      const relaciones = await Crud_Catalogos(
        "remolques_transportistas/id_transportista/" + idTransp, "", "get", "", [], "", "", "", []
      );

      const relacionActiva = Array.isArray(relaciones) && relaciones.find(
        r => r.idRemolque === remolqueExistente.idRemolque && r.estatus !== false
      );

      if (relacionActiva) {
        NotificationManager.info(
          "Este remolque ya existe en tu catálogo",
          "Remolque existente"
        );
        setCrudbutonEnable(true);
        return;
      }

      // Verificar si tiene relación desactivada con este transportista (para reactivar)
      const relacionDesactivada = Array.isArray(relaciones) && relaciones.find(
        r => r.idRemolque === remolqueExistente.idRemolque && r.estatus === false
      );

      if (relacionDesactivada) {
        // Reactivar la relación existente
        await Crud_Catalogos(
          "remolques_transportistas/activar/" + remolqueExistente.idRemolque + "/" + idTransp,
          "", "put", "", {}, "", "", "", []
        );
        NotificationManager.success("Remolque vinculado exitosamente a tu catálogo", "Éxito");
        if (onSave) {
          onSave({
            idRemolque: remolqueExistente.idRemolque,
            placa: remolqueExistente.placa,
            economico: remolqueExistente.economico,
            remolquesTipos: remolqueExistente.remolquesTipos,
          });
        }
        cerrarModal();
        return;
      }

      // No tiene relación → crear nueva usando POST remolques_transportistas
      await Crud_Catalogos("remolques_transportistas", "", "post", "", {
        idRemolque: remolqueExistente.idRemolque,
        idTransportista: idTransp
      }, "", "", "", []);

      NotificationManager.success("Remolque vinculado exitosamente a tu catálogo", "Éxito");
      if (onSave) {
        onSave({
          idRemolque: remolqueExistente.idRemolque,
          placa: remolqueExistente.placa,
          economico: remolqueExistente.economico,
          remolquesTipos: remolqueExistente.remolquesTipos,
        });
      }
      cerrarModal();

    } catch (error) {
      console.error("Error al vincular remolque existente:", error);
      NotificationManager.error("Error al vincular el remolque", "Error");
      setCrudbutonEnable(true);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    setCrudbutonEnable(false);

    const remolqueBase = {
      placa: (formulario.placa || "").trim().toUpperCase(),
      economico: (formulario.economico || "").trim(),
      remolquesTipos: {
        idRemolque: formulario.tipoRemolque?.value
      }
    };

    if (accion === "editar") {
      // Edición: mantiene el transportista existente (un solo registro)
      const remolqueDTO = { ...remolqueBase, idTransportista: idTransportista };
      Crud_Catalogos(`remolques/${elementos.idRemolque}`, "", "put", "", remolqueDTO, "", "", "", [])
        .then(() => {
          NotificationManager.success("Remolque actualizado exitosamente", "Éxito");
          if (onSave) {
            onSave({
              idRemolque: elementos.idRemolque,
              placa: remolqueDTO.placa,
              economico: remolqueDTO.economico,
              remolquesTipos: formulario.tipoRemolque
                ? { idRemolque: formulario.tipoRemolque.value, nombre: formulario.tipoRemolque.label }
                : remolqueDTO.remolquesTipos,
            });
          }
          cerrarModal();
        })
        .catch(err => {
          console.error("Error al actualizar remolque:", err);
          NotificationManager.error(
            err.response?.data?.message || err.response?.data || "Error al guardar el remolque",
            "Error"
          );
          setCrudbutonEnable(true);
        });
      return;
    }

    // Creación:
    // - Catálogo normal (multiPlataforma=true): un remolque por cada plataforma
    //   (transportista de menor id por plataforma).
    // - Cualquier otro flujo (naviero, etc.): se liga solo a idTransportista.
    const idsTransportista = (multiPlataforma && transportistasPorPlataforma.length > 0)
      ? transportistasPorPlataforma.map(sel => sel.idTransportista)
      : [idTransportista];
    const idsTransportistaUnicos = [...new Set(idsTransportista.filter(Boolean))];

    if (idsTransportistaUnicos.length === 0) {
      NotificationManager.error(
        "No se pudo obtener el transportista. Recarga la página e intenta nuevamente.",
        "Error de configuración"
      );
      setCrudbutonEnable(true);
      return;
    }

    Promise.all(idsTransportistaUnicos.map(idT =>
      Crud_Catalogos("remolques", "", "post", "", { ...remolqueBase, idTransportista: idT }, "", "", "", [])
        .then(response => ({ ok: true, response, idT }))
        .catch(err => ({ ok: false, err, idT }))
    ))
      .then((resultados) => {
        const creados = resultados.filter(r => r.ok);
        const fallidos = resultados.filter(r => !r.ok);

        // Para los que fallaron (posible duplicado), intentar vincular el remolque existente
        fallidos.forEach(f => {
          if (f.idT) vincularRemolqueExistente(remolqueBase.placa, f.idT);
        });

        if (creados.length > 0) {
          const primera = creados[0].response;
          NotificationManager.success(
            `Remolque creado exitosamente (${creados.length} registro${creados.length === 1 ? "" : "s"})`,
            "Éxito"
          );
          if (onSave) {
            onSave({
              idRemolque: primera?.idRemolque,
              placa: remolqueBase.placa,
              economico: remolqueBase.economico,
              remolquesTipos: formulario.tipoRemolque
                ? { idRemolque: formulario.tipoRemolque.value, nombre: formulario.tipoRemolque.label }
                : remolqueBase.remolquesTipos,
            });
          }
          cerrarModal();
        } else if (fallidos.length === 0) {
          setCrudbutonEnable(true);
        }
        // Si todos fallaron, vincularRemolqueExistente ya maneja el estado del botón.
      });
  };

  return (
    <div className="remolque-form-container">
      <div className="remolque-header">
        <Icon name="package" className="header-icon" />
        <h2>{accion === "nuevo" ? "Nuevo Remolque" : "Editar Remolque"}</h2>
      </div>

      <Form onSubmit={handleSubmit} className="remolque-form">
        <div className="form-section">
          <div className="form-field">
            <label className="field-label">
              <Icon name={accion === "editar" ? "lock" : "hash"} />
              Placa {accion === "editar" && <span style={{ fontSize: '11px', color: '#888', marginLeft: '4px' }}>(no modificable)</span>}
            </label>
            <Form.Input 
              name="placa" 
              required 
              value={formulario.placa}
              readOnly={accion === "editar"}
              onChange={(e) => accion !== "editar" && setFormulario({...formulario, placa: e.target.value.toUpperCase()})}
              placeholder="Ej: ABC123"
              style={accion === "editar" ? { backgroundColor: '#f0f0f0', cursor: 'not-allowed' } : {}}
            />
          </div>

          <div className="form-field">
            <label className="field-label">
              <Icon name="tag" />
              Económico
            </label>
            <Form.Input 
              name="economico" 
              required 
              value={formulario.economico}
              onChange={(e) => setFormulario({...formulario, economico: e.target.value})}
              placeholder="Ej: REM-001"
            />
          </div>

          <div className="form-field">
            <label className="field-label">
              <Icon name="package" />
              Tipo de Remolque
            </label>
            <BaseSelect 
              name="tipoRemolque" 
              value={formulario.tipoRemolque}
              onChange={(val) => setFormulario(prev => ({...prev, tipoRemolque: val}))}
              options={remolquesOpciones}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 100001 }) }}
              blurInputOnSelect={false}
              placeholder="Selecciona una opción"
            />
          </div>
        </div>

        <div className="form-actions">
          <Button type="submit" color="primary" disabled={!crudbutonEnable}>
            <Icon name="save" />
            {accion === "nuevo" ? "Guardar" : "Actualizar"}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default RemolquesForm;
